const InstrumentInstanceIndex = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceIndex");
const InstrumentInstanceDetail = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceDetail");
const InstrumentInstanceAdd = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceAdd");
const InstrumentInstanceEdit = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceEdit");
const InstrumentInstanceSingle = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceSingle");
const InstrumentInstanceAuditTrail = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceAuditTrail");
const InstrumentInstanceAuditTrailHistory = () =>
  import("@/pages/lab/instrumentinstance/InstrumentInstanceAuditTrailHistory");

export class InstrumentInstanceRoutes {
  constructor() {
    this.route_root = "instrument-instances";
    this.type_single = "Lab Instrument";
    this.type_plural = "Lab Instruments";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c('router-view')
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List of ${this.type_plural}`,
            component: InstrumentInstanceIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: InstrumentInstanceAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":instrument_instance_id",
            component: InstrumentInstanceSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: InstrumentInstanceDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: InstrumentInstanceEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: InstrumentInstanceAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: InstrumentInstanceAuditTrailHistory,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
